type Options = {
  includeDecimals: boolean;
};

export default function formatCurrency(
  amount: number | string,
  options: Options = { includeDecimals: true },
) {
  if (typeof amount === "string") {
    return "Ogiltigt nummer";
  }

  if (options.includeDecimals) {
    return new Intl.NumberFormat("sv", {
      style: "currency",
      currency: "SEK",
    }).format(amount);
  }

  return new Intl.NumberFormat("sv", {
    style: "currency",
    currency: "SEK",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}
